module.exports = __webpack_public_path__ + "static/img/08034D_1_R_20210930_LC.4004901.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/08034D_1_R_20210930_LC.png
// module id = AR8W
// module chunks = 0